<template>
	<div class="user-watches-device-form">
		<spinner v-if="device.loading"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.uid" name="device_imei" :placeholder="$t('labels.general.imei')" rules="required"/>
			<input-text v-model="model.phone" name="phone_number" :placeholder="$t('labels.general.phone')" rules="required"/>
			<input-text v-model="model.name" name="device_name" :placeholder="$t('labels.general.name')" rules="required"/>
			<input-select v-model="model.group_id" :options="groupOptions" name="device_group" :placeholder="$t('base.general.group')" rules="required"/>
			<error-box v-if="form_error" :error="form_error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import ApiCollection from '@/classes/api/ApiCollection'
import Device from '@/classes/Device'
import GroupCollection from '@/classes/GroupCollection'
export default {
	props: [
		'user_uid',
		'device_id',
		'action'
	],
	data () {
		return {
			loading: false,
			form_error: null,
			model: {
				uid: '',
				phone: '',
				name: '',
				group_id: ''
			},
			device: new ApiObject(),
			groups: new ApiCollection(),
			groupOptions: []
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.action) {
				case 'add':
					this.addDevice()
					break
				case 'edit':
					this.editDevice()
					break
				default:
					this.$log.warn('device form', 'action not set')()
			}
		},
		getGroups () {
			this.groups.loading = true
			this.groups.data = []
			this.$api.groups.devices.getAllAvailable(this, this.user_uid)
				.then(response => {
					this.$log.info('device form', 'groups.devices.getAll OK', response)()
					this.groups.data = new GroupCollection(response.body)
					this.groupOptions = this.groups.toSelectOptions()
				}).catch(error => {
					this.$log.error('device form', 'groups.devices.getAll ERROR', error)()
					this.groups.error = error
				}).finally(() => {
					this.groups.loading = false
				})
		},
		getDevice () {
			this.device.loading = true
			this.$api.devices.get(this, this.user_uid, this.device_id)
				.then(response => {
					this.$log.info('device form', 'devices.get OK', response)()
					this.device.data = new Device(response.body)
					this.model = this.device.data
				}).catch(error => {
					this.$log.error('device form', 'devices.get ERROR', error)()
					this.device.error = error
				}).finally(() => {
					this.device.loading = false
				})
		},
		addDevice () {
			this.loading = true
			this.$api.devices.add(this, this.user_uid, this.model)
				.then(response => {
					this.$log.info('device form', 'devices.add OK', response)()
					this.$emit('done')
				}).catch(error => {
					this.$log.error('device form', 'devices.add ERROR', error)()
					this.form_error = error
				}).finally(() => {
					this.loading = false

				})
		},
		editDevice () {
			this.loading = true
			this.$api.devices.edit(this, this.user_uid, this.model)
				.then(response => {
					this.$log.info('device form', 'devices.edit OK', response)()
					this.$emit('done')
				}).catch(error => {
					this.$log.error('device form', 'devices.edit ERROR', error)()
					this.form_error = error
				}).finally(() => {
					this.loading = false
				})
		}
	},
	created () {
		if (this.action === 'edit') {
			this.getDevice()
		}
		this.getGroups()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesFormDevice.vue